import {
  type Components,
  Paper,
  type PaperProps,
  type Theme,
} from "@mui/material";
import { DefaultSelectMenuElevation } from "./covestro-constants";

const ElevatedPaper = (props: PaperProps) => (
  <Paper elevation={DefaultSelectMenuElevation} {...props} />
);

export const covestroMuiAutocomplete: Components<Theme>["MuiAutocomplete"] = {
  defaultProps: {
    PaperComponent: ElevatedPaper,
  },
};
